import {
  GET_INBOX_MAILS,
  GET_INBOX_MAILS_FAIL,
  GET_INBOX_MAILS_SUCCESS,
  SEND_MAIL_TO_USER,
  SEND_MAIL_TO_USER_SUCCESS,
  SEND_MAIL_TO_USER_FAIL,
  ADD_EMAIL_SIGN,
  ADD_EMAIL_SIGN_SUCCESS,
  ADD_EMAIL_SIGN_FAIL,
  SET_MAIL_READ,
  SET_MAIL_READ_FAIL,
  SET_MAIL_READ_SUCCESS,
  GET_IMPORTANT_MAILS,
  GET_IMPORTANT_MAILS_FAIL,
  GET_IMPORTANT_MAILS_SUCCESS,
  GET_PARTICIPANT_EMAILS,
  GET_PARTICIPANT_EMAILS_FAIL,
  GET_PARTICIPANT_EMAILS_SUCCESS,
  GET_DRAFT_MAILS,
  GET_DRAFT_MAILS_FAIL,
  GET_DRAFT_MAILS_SUCCESS,
  GET_SENT_MAILS,
  GET_SENT_MAILS_FAIL,
  GET_SENT_MAILS_SUCCESS,
  REPLY_TO_EMAIL,
  REPLY_TO_EMAIL_SUCCESS,
  REPLY_TO_EMAIL_FAIL,
  FREE_EMAIL_NOTIFICATIONS,
  FREE_EMAIL_NOTIFICATIONS_SUCCESS,
  FREE_EMAIL_NOTIFICATIONS_FAIL,
  GET_STORED_EMAILS,
  GET_STORED_EMAILS_SUCCESS,
  GET_STORED_EMAILS_FAIL,
  GET_ADDRESS_BOOK,
  GET_ADDRESS_BOOK_SUCCESS,
  GET_ADDRESS_BOOK_FAIL,
  REMOVE_ADDRESS_BOOK_EMAIL_SUCCESS,
  REMOVE_ADDRESS_BOOK_EMAIL_FAIL,
  REMOVE_ADDRESS_BOOK_EMAIL,
} from "./actionTypes";

export const removeEmail = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: REMOVE_ADDRESS_BOOK_EMAIL,
  payload: { data, onError, onSuccess },
});

export const removeEmailSuccess = data => ({
  type: REMOVE_ADDRESS_BOOK_EMAIL_SUCCESS,
  payload: data,
});

export const removeEmailFail = error => ({
  type: REMOVE_ADDRESS_BOOK_EMAIL_FAIL,
  payload: error,
});

export const getAddressBookList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: GET_ADDRESS_BOOK,
  payload: { data, onError, onSuccess },
});

export const getAddressBookListSuccess = data => ({
  type: GET_ADDRESS_BOOK_SUCCESS,
  payload: data,
});

export const getAddressBookListFail = error => ({
  type: GET_ADDRESS_BOOK_FAIL,
  payload: error,
});

export const getStoredEmails = data => ({
  type: GET_STORED_EMAILS,
  payload: data,
});

export const getStoredEmailsSuccess = data => ({
  type: GET_STORED_EMAILS_SUCCESS,
  payload: data,
});

export const getStoredEmailsFail = error => ({
  type: GET_STORED_EMAILS_FAIL,
  payload: error,
});

export const freeEmailNotification = (data, dispatch) => ({
  type: FREE_EMAIL_NOTIFICATIONS,
  payload: { data, dispatch },
});

export const freeEmailNotificationSuccess = data => ({
  type: FREE_EMAIL_NOTIFICATIONS_SUCCESS,
  payload: data,
});

export const freeEmailNotificationFail = error => ({
  type: FREE_EMAIL_NOTIFICATIONS_FAIL,
  payload: error,
});

export const replyToEmail = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: REPLY_TO_EMAIL,
  payload: { data, onSuccess, onError },
});

export const replyToEmailSuccess = data => ({
  type: REPLY_TO_EMAIL_SUCCESS,
  payload: data,
});

export const replyToEmailFail = error => ({
  type: REPLY_TO_EMAIL_FAIL,
  payload: error,
});

export const getInboxMails = data => ({
  type: GET_INBOX_MAILS,
  payload: data,
});

export const getInboxMailsSuccess = data => ({
  type: GET_INBOX_MAILS_SUCCESS,
  payload: data,
});

export const getInboxMailsFail = error => ({
  type: GET_INBOX_MAILS_FAIL,
  payload: error,
});

export const sendMailForUser = (data, onSuccess = () => {}, onError = () => {}) => ({
  type: SEND_MAIL_TO_USER,
  payload: { data, onSuccess, onError },
});

export const sendMailForUserSuccess = data => ({
  type: SEND_MAIL_TO_USER_SUCCESS,
  payload: data,
});

export const sendMailForUserFail = error => ({
  type: SEND_MAIL_TO_USER_FAIL,
  payload: error,
});

export const addEmailSign = inboxmail => ({
  type: ADD_EMAIL_SIGN,
  payload: inboxmail,
});

export const addEmailSignSuccess = inboxmail => ({
  type: ADD_EMAIL_SIGN_SUCCESS,
  payload: inboxmail,
});

export const addEmailSignFail = error => ({
  type: ADD_EMAIL_SIGN_FAIL,
  payload: error,
});

export const setMailRead = data => ({
  type: SET_MAIL_READ,
  payload: data,
});

export const setMailReadSuccess = starredmail => ({
  type: SET_MAIL_READ_SUCCESS,
  payload: starredmail,
});

export const setMailReadFail = error => ({
  type: SET_MAIL_READ_FAIL,
  payload: error,
});

export const getImportantMails = () => ({
  type: GET_IMPORTANT_MAILS,
});

export const getImportantMailsSuccess = importantmail => ({
  type: GET_IMPORTANT_MAILS_SUCCESS,
  payload: importantmail,
});

export const getImportantMailsFail = error => ({
  type: GET_IMPORTANT_MAILS_FAIL,
  payload: error,
});

export const getDraftMails = () => ({
  type: GET_DRAFT_MAILS,
});

export const getDraftMailsSuccess = draftmail => ({
  type: GET_DRAFT_MAILS_SUCCESS,
  payload: draftmail,
});

export const getDraftMailsFail = error => ({
  type: GET_DRAFT_MAILS_FAIL,
  payload: error,
});

export const getSentMails = () => ({
  type: GET_SENT_MAILS,
});

export const getSentMailsSuccess = sentmail => ({
  type: GET_SENT_MAILS_SUCCESS,
  payload: sentmail,
});

export const getSentMailsFail = error => ({
  type: GET_SENT_MAILS_FAIL,
  payload: error,
});

export const getParticipantEmail = (data = {}) => ({
  type: GET_PARTICIPANT_EMAILS,
  payload: data,
});

export const getParticipantEmailSuccess = data => ({
  type: GET_PARTICIPANT_EMAILS_SUCCESS,
  payload: data,
});

export const getParticipantEmailFail = error => ({
  type: GET_PARTICIPANT_EMAILS_FAIL,
  payload: error,
});
